<ms-market-help *ngIf="showMarketHelp" [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
<div class="option-group-container teams-container triple" [ngClass]="{ 'ht-of-single-row-options': isSingleRowOfOptions() }">
    <ng-container *ngFor="let group of optionGroups | slice: 0 : visibleOptionsLimit; trackBy: trackGroup">
        <div class="attribute-key">
            {{ group.attribute }}
            <ms-promotion-badge class="no-title" *ngIf="isMarketPromoted(group.optionGroupId, group.templateId)" />
        </div>
        <ms-bet-builder-option
            *ngFor="let option of group.options; trackBy: trackOption"
            [option]="option"
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [optionGroup]="optionGroup"
            [event]="event"
            [showMarketAttribute]="false"
            [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
            [sourceOfPick]="sourceOfPick" />
    </ng-container>
</div>
